
import React from "react";
import Body from "./Components/Body";
import AOSProvider from "./Components/AOSProvider";


function App() {
  return (
    <div >
      <AOSProvider/>
     <Body/>
     
    </div>
  );
}

export default App;
